import elementContainsSearchQuery from '../../../components/search/contentSearch/elementContainsSearchQuery';
import getQueryRegex, { QueryMode } from '../../../../common/utils/getQueryRegex';
import { getElementFilterQuery, getElementFilterIds } from '../elementFilterSelector';
import { getElementId } from '../../../../common/elements/utils/elementPropertyUtils';

// FIXME Move towards deleting this if possible
export const elementMatchesElementFilter = (elementFilter, comments) => {
    const filterQuery = getElementFilterQuery(elementFilter);
    const filterIds = getElementFilterIds(elementFilter);

    const matchesQuery = (element) => {
        if (!filterQuery) return true;

        return elementContainsSearchQuery({
            queryRegEx: getQueryRegex(getElementFilterQuery(elementFilter), QueryMode.PHRASE),
            comments,
        })(element);
    };

    const matchesFilterIds = (element) => {
        if (!filterIds || !filterIds.size) return true;

        return filterIds.includes(getElementId(element));
    };

    return (element) => matchesFilterIds(element) || matchesQuery(element);
};
